<template>
    <div>
        <h2 style="padding-top: 10px;">安全用气</h2>
        <Spin fix v-show="isSpinShow">
            <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
        <Row type="flex" justify="center" align="bottom" v-for="item in formInsert" 
            style="padding:10px 0px 10px 0px">
            <Col span=6>
                {{item.cnName}}
            </Col>
            <Col span=4>
                <Select v-model="item.h" size="small" placeholder="">
                    <Option v-for="hour in hourList" :key="hour" :value="hour">{{hour}}</Option>
                </Select>
            </Col>
            <Col span=2>
                {{item.unit}}
            </Col>
            <Col span=4>
                <Select v-model="item.m" size="small" placeholder="">
                    <Option v-for="min in minList" :key="min" :value="min">{{min}}</Option>
                </Select>
            </Col>
            <Col span=2>
                分
            </Col>
        </Row>
        <div style="width: 90%;left: 5%;position:relative;">
            <Button long type="primary" @click="downInstructionData">下发</Button>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                isSpinShow: false,
                isLoadingButton: false,
                height: window.innerHeight,
                placement: 'right',
                formInsert: [],
                meterId: "",
                commandType: "0x15",
                hourList: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
                minList: [0,10,20,30,40,50]
            }
        },
        methods: {
            getDownInstruction(param) {
                let that = this;
                that.meterId = param;
                that.isSpinShow = true;
                $.ajax({
                    url: "/api/instructions/downInstruction",
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify({
                        commandDeviceId: that.meterId,
                        commandType: that.commandType
                    }),
                    dataType: "json",
                    success: function(receiveData) {
                        if (receiveData.errorCode == 0) {
                            that.formInsert = receiveData.body;
                            that.formInsert.map(item => {
                                item.h = (item.default / 10) >> 0;
                                item.m = item.default % 10 * 10;
                                console.log(item.h);
                                console.log(item.m);
                            });
                        } else {
                            that.$Notice.error({
                                title: "异常",
                                desc: receiveData.errorInfo
                            });
                        }
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function() {
                        that.isSpinShow = false;
                    }
                });
            },
            downInstructionData() {
                let that = this;
                let downData = {
                    command: {
                        paras: {

                        }
                    },
                    commandType: that.commandType,
                    deviceId: that.meterId
                };
                that.formInsert.map(item => {
                    downData.command.paras[item.name] = item.h * 10 + (item.m / 10) >> 0;
                });
                console.log(downData);
                that.isLoadingButton = true;
                $.ajax({
                    url: "/api/instructions/downInstructionData",
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify(downData),
                    dataType: "json",
                    success: function(receiveData) {
                        if (receiveData.errorCode == 0) {
                            that.$Notice.success({
                                title: "成功",
                                desc: "参数下发成功"
                            });
                        } else {
                            that.$Notice.error({
                                title: "异常",
                                desc: receiveData.errorInfo
                            });
                        }
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function() {
                        that.isLoadingButton = false;
                    }
                });
            }
        }
    }
</script>

<style>
</style>
